import { ParsedQuery } from '@/types/parsedQuery.js';
import { parse, stringify } from '@contra/utilities/queryString';

export const appendSearch = (path: string, search?: ParsedQuery): string => {
  const [nextPath, currentQuery] = path.split('?');

  if (!search) {
    return path;
  }

  const nextQuery = stringify(search ?? {});

  const nextParameters = currentQuery
    ? stringify(parse(currentQuery + '&' + nextQuery))
    : nextQuery;

  if (!nextParameters) {
    return nextPath;
  }

  const isHashLink = path.startsWith('/#');

  const withHashUrl = `/?${nextParameters}${nextPath?.slice(1)}`;
  const noHashUrl = `${nextPath}?${nextParameters}`;

  return isHashLink ? withHashUrl : noHashUrl;
};
